/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import { Box, Typography, Grid } from '@mui/material';

const ShareScreen = (props) =>
{
	const { callType, localStream, remoteStream, callData, callDetails, userData, screenStreamRef } = props;

	const shareStreemRef = useRef<any>(null);
	const remoteVideoStreemRef = useRef<any>(null);
	const isShare = callDetails?.screenShareId === userData?.userId;

	useEffect(() =>
	{
		if (shareStreemRef.current)
		{
			shareStreemRef.current.srcObject = isShare ? screenStreamRef.current : remoteStream;
		}

		if (remoteVideoStreemRef.current)
		{
			remoteVideoStreemRef.current.srcObject = isShare ? remoteStream : localStream;
		}
	}, [ localStream, remoteStream, callData?.videoCall, callData?.roomModeView ]);

	const selfData:any = callDetails && Object.values(callDetails?.participants)?.find((i:any) => i?.id === userData?.userId);
	const callerData:any = callDetails && Object.values(callDetails?.participants)?.find((i:any) => i?.id !== userData?.userId);
	const isVideoPused = isShare ? callerData?.isVideoPaused : selfData?.isVideoPaused;

	const imageRef = useRef<string>(isShare ? callerData?.profileImg : selfData?.profileImg ?? '/images/icons/defaultUser.svg');

	const handleErrorImage = () =>
	{
		imageRef.current = '/images/icons/defaultUser.svg';
	};

	return (
		<Grid container spacing={2} sx={{ height: '100%', alignItems: 'center' }}>
			<Grid item xs={12} sm={12} md={8}>
				<Box
					sx={{
						height         : '100%',
						bgcolor        : 'rgba(255, 255, 255, 0.05)',
						position       : 'relative',
						overflow       : 'hidden',
						borderRadius   : 2,
						display        : 'flex',
						alignItems     : 'center',
						justifyContent : 'center'

					}}
				>
					<video
						ref={shareStreemRef}
						autoPlay
						muted
						playsInline
						style={{
							width        : '100%',
							height       : '100%',
							objectFit    : 'contain',
							borderRadius : '8px',
							aspectRatio  : '16/9'
						}}
					/>
					{/* User label */}
					<Box
						sx={{
							position     : 'absolute',
							bottom       : 50,
							left         : 10,
							bgcolor      : 'rgba(0,0,0,0.5)',
							px           : 1,
							borderRadius : 1
						}}
					>
						<Typography variant='body2' sx={{ color: 'white' }}>
							{isShare ? 'you' : callerData?.name}
						</Typography>
					</Box>
				</Box>
			</Grid>

			<Grid item xs={12} sm={12} md={4}>
				<Box
					sx={{
						height         : '300px',
						bgcolor        : 'rgba(255, 255, 255, 0.05)',
						position       : 'relative',
						overflow       : 'hidden',
						borderRadius   : 2,
						display        : 'flex',
						alignItems     : 'center',
						justifyContent : 'center'
					}}
				>
					{/* Video placeholder */}
					{callType === 'video' &&
					<video
						ref={remoteVideoStreemRef}
						autoPlay
						muted
						playsInline
						style={{
							width        : '100%',
							height       : '100%',
							objectFit    : 'cover',
							borderRadius : '8px',
							display      : isVideoPused ? 'none' : ''
						}}
					/>}
					{(callType === 'audio' || isVideoPused) &&
					<Box
						component='img'
						src={imageRef.current || '/images/icons/defaultUser.svg'}
						alt='Caller video'
						sx={{
							width        : '200px',
							height       : '200px',
							borderRadius : '100px',
							objectFit    : 'cover'
						}}
						onError={handleErrorImage}
					/>}

					{/* Remote user label */}
					<Box
						sx={{
							position     : 'absolute',
							bottom       : 12,
							left         : 10,
							bgcolor      : 'rgba(0,0,0,0.5)',
							px           : 1,
							borderRadius : 1
						}}
					>
						<Typography variant='body2' sx={{ color: 'white' }}>
							{isShare ? callerData?.name : 'you'}
						</Typography>
					</Box>
				</Box>
			</Grid>
		</Grid>
	);
};

export default ShareScreen;